import type {DiscoveryServiceFactory, DiscoveryStrategyFactory} from '../discovery/index.ts';
import type {Properties} from './Properties.ts';

export interface DiscoveryStrategyConfig {
    readonly discoveryStrategyFactory?: DiscoveryStrategyFactory
    readonly properties: Properties
}
export interface DiscoveryConfig {
    readonly discoveryStrategyConfigs: ReadonlyArray<DiscoveryStrategyConfig>
    readonly discoveryServiceFactory?: DiscoveryServiceFactory
}

export class DefaultDiscoveryConfig implements DiscoveryConfig
{
    discoveryStrategyConfigs: DiscoveryStrategyConfig[] = [];
    discoveryServiceFactory?: DiscoveryServiceFactory;

    get enabled() {
        return this.discoveryStrategyConfigs.length > 0;
    }
}
